import r from "react";
import { DataGridContext as e } from "./index.es596.js";
function a() {
  const t = r.useContext(e);
  if (!t)
    throw new Error("useDataGridContext must be used within a DataGridContextProvider");
  return t;
}
export {
  a as useDataGridContext
};
//# sourceMappingURL=index.es764.js.map
